module.exports = __webpack_public_path__ + "static/media/pic6.f5d48cd0.jpg";